import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SelectionCardsComponent } from './selection-cards.component.js';
import { RouterModule } from '@angular/router';
import { AppFlexModule } from '../flex/index.js';
import { ImagesModule } from "lib/images/images.module.js";
import { CardModule } from "../card/card.module.js";
import { ButtonModule } from "../buttons/button.module.js";

@NgModule({
    declarations: [SelectionCardsComponent],
    exports: [SelectionCardsComponent],
    imports: [CommonModule, RouterModule, AppFlexModule, ImagesModule, CardModule, ButtonModule]
})
export class SelectionCardsModule {}
